export class UserModules {
  constructor(data = {}) {
    this.pbx = data['pbx'] || null;
    this.informer = data['informer'] || null;
    this.predictive = data['predictive'] || null;
  }
}
